import './CategoryTitle.svelte.css';
/* src/components/CategoryTitle.svelte generated by Svelte v3.37.0 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	attr,
	binding_callbacks,
	check_outros,
	component_subscribe,
	create_component,
	create_in_transition,
	destroy_component,
	detach,
	element,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	prevent_default,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	set_store_value,
	space,
	text,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import { fade } from "../../_snowpack/pkg/svelte/transition.js";
import { DialogOverlay } from "../../_snowpack/pkg/svelte-accessible-dialog.js";
import { CategoryThingsContent } from "./index.js";

import {
	EditButton,
	DeleteButton,
	SubmitButton,
	CancelButton
} from "./button-elements/index.js";

import { createCategoryJdId } from "../utils/jd-id-builder.js";
import { reorderItems } from "../utils/dnd-helpers.js";
import { groupedCategories } from "../stores/index.js";

function create_else_block(ctx) {
	let div0;
	let code;
	let t0_value = createCategoryJdId(/*category*/ ctx[0].order, /*area*/ ctx[1].order) + "";
	let t0;
	let t1;
	let strong;
	let t2_value = /*category*/ ctx[0].name + "";
	let t2;
	let t3;
	let div1;
	let button;
	let t5;
	let editbutton;
	let t6;
	let deletebutton;
	let current;
	let mounted;
	let dispose;
	editbutton = new EditButton({});
	editbutton.$on("click", /*toggleEditing*/ ctx[9]);
	deletebutton = new DeleteButton({});
	deletebutton.$on("click", /*click_handler_1*/ ctx[16]);

	return {
		c() {
			div0 = element("div");
			code = element("code");
			t0 = text(t0_value);
			t1 = space();
			strong = element("strong");
			t2 = text(t2_value);
			t3 = space();
			div1 = element("div");
			button = element("button");
			button.textContent = "+";
			t5 = space();
			create_component(editbutton.$$.fragment);
			t6 = space();
			create_component(deletebutton.$$.fragment);
			attr(code, "class", "jd-id");
			attr(strong, "class", "jd-name svelte-jhej9j");
			attr(div0, "class", "jd-id-and-name svelte-jhej9j");
			attr(button, "class", "jd-icon-button jd-icon-button--standard");
			attr(div1, "class", "jd-actions svelte-jhej9j");
		},
		m(target, anchor) {
			insert(target, div0, anchor);
			append(div0, code);
			append(code, t0);
			append(div0, t1);
			append(div0, strong);
			append(strong, t2);
			insert(target, t3, anchor);
			insert(target, div1, anchor);
			append(div1, button);
			append(div1, t5);
			mount_component(editbutton, div1, null);
			append(div1, t6);
			mount_component(deletebutton, div1, null);
			current = true;

			if (!mounted) {
				dispose = listen(button, "click", /*click_handler*/ ctx[15]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if ((!current || dirty & /*category, area*/ 3) && t0_value !== (t0_value = createCategoryJdId(/*category*/ ctx[0].order, /*area*/ ctx[1].order) + "")) set_data(t0, t0_value);
			if ((!current || dirty & /*category*/ 1) && t2_value !== (t2_value = /*category*/ ctx[0].name + "")) set_data(t2, t2_value);
		},
		i(local) {
			if (current) return;
			transition_in(editbutton.$$.fragment, local);
			transition_in(deletebutton.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(editbutton.$$.fragment, local);
			transition_out(deletebutton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div0);
			if (detaching) detach(t3);
			if (detaching) detach(div1);
			destroy_component(editbutton);
			destroy_component(deletebutton);
			mounted = false;
			dispose();
		}
	};
}

// (47:2) {#if isEditing}
function create_if_block(ctx) {
	let div;
	let form;
	let input;
	let t0;
	let submitbutton;
	let t1;
	let cancelbutton;
	let current;
	let mounted;
	let dispose;

	submitbutton = new SubmitButton({
			props: {
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	cancelbutton = new CancelButton({
			props: {
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	cancelbutton.$on("click", /*toggleEditing*/ ctx[9]);

	return {
		c() {
			div = element("div");
			form = element("form");
			input = element("input");
			t0 = space();
			create_component(submitbutton.$$.fragment);
			t1 = space();
			create_component(cancelbutton.$$.fragment);
			attr(input, "class", "jd-text-input");
			attr(input, "type", "text");
			attr(form, "class", "jd-form-set svelte-jhej9j");
			attr(div, "class", "jd-category__title__spacer svelte-jhej9j");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, form);
			append(form, input);
			/*input_binding*/ ctx[12](input);
			set_input_value(input, /*newName*/ ctx[4]);
			append(form, t0);
			mount_component(submitbutton, form, null);
			append(div, t1);
			mount_component(cancelbutton, div, null);
			current = true;

			if (!mounted) {
				dispose = [
					listen(input, "input", /*input_input_handler*/ ctx[13]),
					listen(input, "keydown", /*keydown_handler*/ ctx[14]),
					listen(form, "submit", prevent_default(/*saveName*/ ctx[8]))
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*newName*/ 16 && input.value !== /*newName*/ ctx[4]) {
				set_input_value(input, /*newName*/ ctx[4]);
			}

			const submitbutton_changes = {};

			if (dirty & /*$$scope*/ 262144) {
				submitbutton_changes.$$scope = { dirty, ctx };
			}

			submitbutton.$set(submitbutton_changes);
			const cancelbutton_changes = {};

			if (dirty & /*$$scope*/ 262144) {
				cancelbutton_changes.$$scope = { dirty, ctx };
			}

			cancelbutton.$set(cancelbutton_changes);
		},
		i(local) {
			if (current) return;
			transition_in(submitbutton.$$.fragment, local);
			transition_in(cancelbutton.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(submitbutton.$$.fragment, local);
			transition_out(cancelbutton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			/*input_binding*/ ctx[12](null);
			destroy_component(submitbutton);
			destroy_component(cancelbutton);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (59:8) <SubmitButton>
function create_default_slot_2(ctx) {
	let t;

	return {
		c() {
			t = text("save");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (61:6) <CancelButton on:click={toggleEditing}>
function create_default_slot_1(ctx) {
	let t;

	return {
		c() {
			t = text("esc");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (78:0) <DialogOverlay isOpen={isCategoryOpen} onDismiss={closeCategoryDetail}>
function create_default_slot(ctx) {
	let categorythingscontent;
	let current;

	categorythingscontent = new CategoryThingsContent({
			props: { category: /*activeCategory*/ ctx[6] }
		});

	categorythingscontent.$on("close", /*closeCategoryDetail*/ ctx[11]);

	return {
		c() {
			create_component(categorythingscontent.$$.fragment);
		},
		m(target, anchor) {
			mount_component(categorythingscontent, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const categorythingscontent_changes = {};
			if (dirty & /*activeCategory*/ 64) categorythingscontent_changes.category = /*activeCategory*/ ctx[6];
			categorythingscontent.$set(categorythingscontent_changes);
		},
		i(local) {
			if (current) return;
			transition_in(categorythingscontent.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(categorythingscontent.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(categorythingscontent, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let current_block_type_index;
	let if_block;
	let div_intro;
	let t;
	let dialogoverlay;
	let current;
	const if_block_creators = [create_if_block, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*isEditing*/ ctx[2]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	dialogoverlay = new DialogOverlay({
			props: {
				isOpen: /*isCategoryOpen*/ ctx[5],
				onDismiss: /*closeCategoryDetail*/ ctx[11],
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			div = element("div");
			if_block.c();
			t = space();
			create_component(dialogoverlay.$$.fragment);
			attr(div, "class", "jd-category__title svelte-jhej9j");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if_blocks[current_block_type_index].m(div, null);
			insert(target, t, anchor);
			mount_component(dialogoverlay, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(div, null);
			}

			const dialogoverlay_changes = {};
			if (dirty & /*isCategoryOpen*/ 32) dialogoverlay_changes.isOpen = /*isCategoryOpen*/ ctx[5];

			if (dirty & /*$$scope, activeCategory*/ 262208) {
				dialogoverlay_changes.$$scope = { dirty, ctx };
			}

			dialogoverlay.$set(dialogoverlay_changes);
		},
		i(local) {
			if (current) return;
			transition_in(if_block);

			if (!div_intro) {
				add_render_callback(() => {
					div_intro = create_in_transition(div, fade, {});
					div_intro.start();
				});
			}

			transition_in(dialogoverlay.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			transition_out(dialogoverlay.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if_blocks[current_block_type_index].d();
			if (detaching) detach(t);
			destroy_component(dialogoverlay, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $groupedCategories;
	component_subscribe($$self, groupedCategories, $$value => $$invalidate(17, $groupedCategories = $$value));
	
	let { category } = $$props;
	let { area } = $$props;
	let isEditing = false;
	let newName = category.name || "";
	let inputRef;

	const handleRemoveCategory = (catId, areaId) => {
		const updatedGroup = reorderItems($groupedCategories[areaId].filter(cat => cat.id !== catId));

		// @ts-ignore
		set_store_value(groupedCategories, $groupedCategories[areaId] = updatedGroup, $groupedCategories);
	};

	const saveName = () => {
		if (!newName) return alert("please fill in name");
		$$invalidate(0, category.name = newName, category);
		groupedCategories.set($groupedCategories);
		$$invalidate(2, isEditing = false);
	};

	const toggleEditing = () => {
		$$invalidate(2, isEditing = !isEditing);
	};

	// Category detail dialog
	let isCategoryOpen;

	let activeCategory;

	const openCategoryDetail = (category, area) => {
		if (activeCategory) return alert("close previous category before editing new one");
		$$invalidate(5, isCategoryOpen = true);

		$$invalidate(6, activeCategory = Object.assign(Object.assign({}, category), {
			jdReadableId: createCategoryJdId(category.order, area.order)
		}));
	};

	const closeCategoryDetail = () => {
		$$invalidate(5, isCategoryOpen = false);
		$$invalidate(6, activeCategory = null);
	};

	function input_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			inputRef = $$value;
			$$invalidate(3, inputRef);
		});
	}

	function input_input_handler() {
		newName = this.value;
		$$invalidate(4, newName);
	}

	const keydown_handler = e => {
		if (e.key === "Escape") $$invalidate(2, isEditing = false);
	};

	const click_handler = () => openCategoryDetail(category, area);
	const click_handler_1 = () => handleRemoveCategory(category.id, area.id);

	$$self.$$set = $$props => {
		if ("category" in $$props) $$invalidate(0, category = $$props.category);
		if ("area" in $$props) $$invalidate(1, area = $$props.area);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*isEditing, inputRef*/ 12) {
			$: if (isEditing && inputRef) inputRef.focus();
		}
	};

	return [
		category,
		area,
		isEditing,
		inputRef,
		newName,
		isCategoryOpen,
		activeCategory,
		handleRemoveCategory,
		saveName,
		toggleEditing,
		openCategoryDetail,
		closeCategoryDetail,
		input_binding,
		input_input_handler,
		keydown_handler,
		click_handler,
		click_handler_1
	];
}

class CategoryTitle extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { category: 0, area: 1 });
	}
}

export default CategoryTitle;